import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AdminUsersMaintenance } from './pages/AdminUsersMaintenance';
import { CategoryMaintenance } from './pages/CategoryMaintenance';
import { Location } from './pages/Location';
import { MailingListMaintenance } from './pages/MailingListMaintenance';
import { NoticeMessageList } from './pages/NoticeMessageList';
import { SendMessage } from './pages/SendMessage';
import { PhrasesMaintenance } from './pages/PhrasesMaintenance';
import { SettingsMaintenance } from './pages/SettingsMaintenance';
import { SignageMaintenance } from './pages/SignageMaintenance';
import { TrainGroupsMaintenance } from './pages/TrainGroupsMaintenance';
import { TrainsMaintenance } from './pages/TrainsMaintenance';
import { Login } from './pages/Login';
import { Provider } from 'react-redux';
import { RootStore } from './redux/RootStore';

export const RouterConfig: React.FC = () => {
  const [isLogin, setIsLogin] = useState(false);
  useEffect(() => {
    const token = sessionStorage.getItem('access-token');
    if (token !== null) {
      setIsLogin(true);
    }
  }, []);

  return (
    <>
      <Provider store={RootStore}>
        <BrowserRouter>
          {isLogin && (
            <Routes>
              <Route index element={<Login setIsLogin={setIsLogin} />} />
              <Route
                path='/login'
                element={<Login setIsLogin={setIsLogin} />}
              />
              <Route path='/location' element={<Location />} />
              <Route path='/message' element={<SendMessage />} />
              <Route path='/messageList' element={<NoticeMessageList />} />
              <Route
                path='/admin/admin_users'
                element={<AdminUsersMaintenance />}
              />
              <Route path='/admin/trains' element={<TrainsMaintenance />} />
              <Route
                path='/admin/train_groups'
                element={<TrainGroupsMaintenance />}
              />
              <Route
                path='/admin/categories'
                element={<CategoryMaintenance />}
              />
              <Route path='/admin/phrases' element={<PhrasesMaintenance />} />
              <Route
                path='/admin/mailinglists'
                element={<MailingListMaintenance />}
              />
              <Route path='/admin/signages' element={<SignageMaintenance />} />
              <Route path='/admin/settings' element={<SettingsMaintenance />} />
            </Routes>
          )}
          {isLogin === false && (
            <Routes>
              <Route
                path='/login'
                element={<Login setIsLogin={setIsLogin} />}
              />
              <Route path='*' element={<Navigate to='/login' replace />} />
            </Routes>
          )}
        </BrowserRouter>
      </Provider>
    </>
  );
};
